export enum VehicleTrailerType {
  BOX_TRAILER = 0,
  CURTAINSIDER_DELTA_OPENING = 1,
  FLATBED = 2,
  LIGHTWEIGHT_CURTAINSIDER = 3,
  BULK_TRAILER = 4,
  TANKER = 5,
  OTHER = 6,
}

export interface IVehicleStatusList {
  id: number;
  description: string;
}

export type IItems = {
  id: number;
  carrier: string;
  vehiclePlate: string;
  trailersplate: string[];
  processId?: number;
  process: string;
  eventTime?: string;
  vehicleEntryAuthorizationStatus: number;
  saleChannelDescription?: string;
  saleChannelId?: number;
  hasWarning: boolean;
  gateEventId: number;
  local: number;
  documents: string[];
  vehicleStepStatus: number;
  lenghtOfStay: string;
  serviceStartTime: string;
  serviceFinishTime: string;
  hasActiveTag: boolean;
};

export interface IVehicleDashboardFilterOptions {
  processId: number[];
  saleChannelId: number[];
  searchFilter: string;
}

export interface IVehicleDashboardFilter {
  itemsByPage: number;
  pageIndex: number;
  orderBy?: string;
}

export interface IVehicleDashboardItem {
  totalItems: number;
  registers: Array<IItems>;
  averageStay: string;
}

export interface IVehicleDashboardState {
  isLoading: boolean;
  items?: Record<string, IVehicleDashboardItem>;
  filter: IVehicleDashboardFilter;
  filterOptions: IVehicleDashboardFilterOptions;
  visibleDrawerViewRegisterVehicleDashboard: boolean;
  visibleDrawerViewCheckinRegisterVehicleDashboard: boolean;
}

export const defaultState: IVehicleDashboardState = {
  isLoading: false,
  items: {},
  visibleDrawerViewRegisterVehicleDashboard: false,
  visibleDrawerViewCheckinRegisterVehicleDashboard: false,
  filter: {
    itemsByPage: 10,
    pageIndex: 1,
    orderBy: null,
  },
  filterOptions: {
    searchFilter: "",
    processId: [],
    saleChannelId: [],
  },
};
